import { useState } from 'react';
import { Row, Col, Radio } from 'antd';
import { getLangList } from '@/lib/i18n';
import StudentManagement from '@containers/humanResourceManagement/studentManagement';
import Countdown from "./Countdown";
import QRCode from "./QRCode";

function Attendance() {
  const [selectValue, setSelectValue] = useState('qrCode');
  const attendanceT: any = getLangList("attendance");
  const options = [
    { label: attendanceT.QRCODE, value: 'qrCode' },
    { label: attendanceT.STUDENT_LIST, value: 'list' },
  ];

  return (
    <>
      <Row justify="center">
        <Col>
          <Countdown />
        </Col>
      </Row>

      <Row gutter={[0, 40]}>
        <Col span={24}>
          <Radio.Group
            options={options}
            onChange={(e) => setSelectValue(e.target.value)}
            value={selectValue}
            buttonStyle="solid"
          />
        </Col>

        <Col span={24}>
          {selectValue === 'qrCode'
            ? <QRCode />
            : <StudentManagement isRollCall />
          }
        </Col>
      </Row>
    </>
  );
}

export default Attendance;